<div class="d-flex flex-column gap-3 pb-3">
    <div *ngFor="let section of [].constructor(2); let i = index">
        <div>
            <div class="item-heading p-3">
                <ngx-skeleton-loader
                    [animation]="'progress'"
                    [count]="1"
                    [theme]="{ width: '100%', height: '24px', margin: '0' }"
                ></ngx-skeleton-loader>
            </div>

            <div
                *ngFor="let subItem of [].constructor(3); let j = index"
                class="item p-3 d-flex"
            >
                <ngx-skeleton-loader
                    [animation]="'progress'"
                    [appearance]="'circle'"
                    [count]="1"
                    [theme]="{ width: '40px', height: '40px', margin: '0' }"
                ></ngx-skeleton-loader>

                <div class="ms-3 w-100">
                    <ngx-skeleton-loader
                        [animation]="'progress'"
                        [count]="1"
                        [theme]="{ width: '60%', height: '25px', margin: '0' }"
                    ></ngx-skeleton-loader>
                </div>
            </div>
        </div>
    </div>
</div>
